import type { IOnboardingStepText } from '../../types/IOnboardingStepText'

export const adverseTexts: Record<string, IOnboardingStepText> = {
  'adverse.intro': {
    title: 'Нежелательные события',
    text: 'Реестр НС: падения, ошибки идентификации, пролежни и другие случаи, которые угрожали пациенту или сотруднику. Покажем, как зарегистрировать событие и найти нужное.',
  },
  'adverse.create': {
    title: 'Регистрация НС',
    text: 'Опишите, что произошло, где и когда. Зарегистрировать событие нужно в течение суток — позже форма отметит просрочку.',
  },
  'adverse.statistics': {
    title: 'Статистика',
    text: 'Графики по НС: сколько событий, каких видов, в каких отделениях и с каким риском.',
  },
  'adverse.reports': {
    title: 'Отчёты',
    text: 'Сводные таблицы по НС за период. Открываются с теми же условиями поиска, что заданы в таблице.',
  },
  'adverse.settings': {
    title: 'Настройки',
    text: 'Справочники модуля: виды и подвиды НС, пороги вероятности и матрица рисков. Доступны администраторам.',
  },
  'adverse.navSettings': {
    title: 'Настройки в боковом меню',
    text: 'Те же настройки открываются с любой страницы: наведите на пункт «Нежелательные события» в боковом меню — появится шестерёнка.',
  },
  'adverse.settings.types': {
    title: 'Виды и подвиды НС',
    text: 'Дерево видов, из которого выбирают при регистрации. Клик по карточке открывает вид: координатор по умолчанию, координаторы по отделениям, последствия. Отметка «Активен» включает и выключает вид, глобальные виды можно только включать и выключать.',
  },
  'adverse.settings.typesShowInForm': {
    title: 'Виды в форме регистрации',
    text: 'Какие виды предлагать сотрудникам при регистрации НС: все, только свои или только глобальные.',
  },
  'adverse.settings.typesView': {
    title: 'Вид дерева',
    text: 'Фильтр, компактный режим и скрытие иерархии меняют только отображение дерева. С включённым перетаскиванием свой вид можно перенести мышью в другую ветку.',
  },
  'adverse.settings.typesCreate': {
    title: 'Новый вид',
    text: 'Добавьте свой вид или подвид НС и назначьте ему координатора.',
  },
  'adverse.settings.probability': {
    title: 'Вероятность и риски',
    text: 'На вкладке «Пороги вероятности» задаётся, сколько событий за расчётный период соответствует каждому уровню. На вкладке «Матрица рисков» — какой риск получается из вероятности и последствий.',
  },
  'adverse.export': {
    title: 'Выгрузить',
    text: 'Скачать таблицу НС с текущими условиями поиска.',
  },
  'adverse.search': {
    title: 'Быстрый поиск',
    text: 'Введите слова и нажмите Enter. Поиск идёт по номеру, описанию, виду, отделению, месту и принятым мерам.',
  },
  'adverse.search.toggle': {
    title: 'Кнопка «Фильтр»',
    text: 'Открывает панель с точными условиями: по полям НС и по ответам анкет. Когда условия заданы, вместо слова «Фильтр» здесь их число.',
  },
  'adverse.filter.presets': {
    title: 'Сохранённые фильтры',
    text: 'Готовые наборы условий: «Требует действия», «Мои активные НС» и ваши собственные. Выберите набор и нажмите «Найти». «Сохранить фильтр» запоминает текущие условия под своим названием.',
  },
  'adverse.filter.words': {
    title: 'Поиск по словам',
    text: 'То же, что быстрый поиск в строке, — его можно сочетать с условиями ниже.',
  },
  'adverse.filter.add': {
    title: 'Условия',
    text: 'Выберите поле — отделение, вид, риск, дату — или анкету и укажите значение. Если условий несколько, выберите, должны выполняться все сразу (И) или хотя бы одно (ИЛИ). У анкеты так же: условие на каждый ответ и своё «И / ИЛИ».',
  },
  'adverse.filter.apply': {
    title: 'Найти и сбросить',
    text: 'Условия применяются только по кнопке «Найти». «Сбросить» очищает поиск и все условия.',
  },
  'adverse.filter.chips': {
    title: 'Применённые условия',
    text: 'Каждое условие видно под строкой поиска. Клик по нему открывает панель для правки, крестик убирает только это условие.',
  },
  'adverse.filters': {
    title: 'Фильтр по колонке',
    text: 'Значок воронки в заголовке открывает ту же панель сразу с условием по этой колонке — останется выбрать значение.',
  },
  'adverse.hideCompleted': {
    title: 'Скрыть завершённые',
    text: 'Оставляет в списке только НС, разбор которых ещё не закончен. Работает вместе с поиском и условиями, «Сбросить фильтры» его не выключает.',
  },
  'adverse.resetFilters': {
    title: 'Сбросить фильтры',
    text: 'Возвращает полный список НС.',
  },
  'adverse.demoRow': {
    title: 'Карточка события',
    text: 'Клик по строке открывает НС. Красная полоса слева — по событию ждут ваших действий.',
  },
  'adverse.form.type': {
    title: 'Вид и подвид',
    text: 'Вид определяет, какие анкеты нужно заполнить по событию. После смены вида сохраните форму — анкеты пересчитаются.',
  },
  'adverse.form.dateTime': {
    title: 'Дата и время',
    text: 'Когда событие произошло, а не когда его зарегистрировали. Если событие зарегистрировали позже чем через сутки, внизу формы появится отметка о просрочке.',
  },
  'adverse.form.risk': {
    title: 'Оценка риска',
    text: 'Вероятность и последствия вместе дают уровень риска — он появится рядом со статусом. Без оценки риска событие не завершить.',
  },
  'adverse.form.place': {
    title: 'Отделение и место',
    text: 'Где произошло событие: отделение обязательно, место — помещение из справочника больницы.',
  },
  'adverse.form.participants': {
    title: 'Участники',
    text: 'Пациенты, сотрудники и посетители, вовлечённые в событие. По пациентам заполняются отдельные анкеты.',
  },
  'adverse.form.description': {
    title: 'Описание',
    text: 'Что случилось и почему, без персональных данных. Чтобы упомянуть участника, наберите «+» и выберите его из списка. Если поле доступно для правки, текст можно надиктовать.',
  },
  'adverse.form.corrective': {
    title: 'Принятые меры',
    text: 'Что уже сделано, чтобы устранить последствия и не допустить повторения.',
  },
  'adverse.form.save': {
    title: 'Сохранить',
    text: 'Сохраняет изменения на вкладке «Форма». Набор доступных полей зависит от вашей роли в событии.',
  },
  'adverse.form.questionnaires': {
    title: 'Анкеты',
    text: 'Вопросы по виду события, по каждому пациенту и по мероприятиям. Набор анкет зависит от вида НС, дополнительную можно добавить кнопкой «Добавить анкету». Ответы сохраняются кнопкой внизу этой вкладки.',
  },
  'adverse.form.files': {
    title: 'Файлы',
    text: 'Фото, сканы и другие документы по событию. Выберите файл, добавьте описание и нажмите «Загрузить». В таблице видно, кто и когда загрузил файл.',
  },
  'adverse.form.historyTab': {
    title: 'История',
    text: 'Кто и когда менял событие.',
  },
  'adverse.form.tasksEar': {
    title: 'Задача координатора',
    text: 'Координатор разбирает событие и отчитывается о мерах. Назначают его здесь, в панели задачи.',
  },
  'adverse.form.assignCoordinator': {
    title: 'Назначить координатора',
    text: 'Пока координатора нет, событие никто не разбирает. Выберите сотрудника — ему придёт задача.',
  },
}
